<div class="container layout-breadcrumb pl-0 pr-0">
    <div class="mb-0 pl-0">
        <div class="route-bar-breadcrumb" style="display: flex;list-style: none;">
                <ng-template ngFor let-item let-last="last" [ngForOf]="items" let-index="index">
                    <li class="text-header-banner" *ngIf="index == 0">
                        <a href="/">{{item.label}} &nbsp;</a>
                    </li>
                    <li class="text-header-banner" *ngIf="index != 0">
                        <a [routerLink]="item.routerLink" *ngIf="item.routerLink && index">&nbsp; {{item.label}} &nbsp;</a>
                        <a [routerLink]="item.routerLink" *ngIf="item.routerLink && !index">{{item.label}} &nbsp;</a>
                        <span style="color: #F2B944;" *ngIf="!item.routerLink"> &nbsp; {{item.label}} &nbsp;</span>
                    </li>
                    
                    <li *ngIf="index != (items.length - 1)"><i class="fa fa-chevron-right" aria-hidden="true"></i></li>

                </ng-template>
        </div>
    </div>
</div>
